import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../assets/images/logo.svg";
import { cn } from "./cn";

/* The card every auth screen sits in: brand bar, then the panel.
 *
 * Shared by login and sign-up so the two cannot drift apart in width, radius,
 * shadow or padding. The amber wash behind the top of the card is decorative.
 */
export const AuthCard = ({ children, className = "" }) => (
  <main className="relative flex-1 flex items-start justify-center px-3 sm:px-4 md:px-6 pt-6 sm:pt-8 md:pt-16 pb-11 sm:pb-14 md:pb-24">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-[720px] max-w-full h-[360px] bg-[radial-gradient(ellipse_at_center_top,rgba(245,157,21,.10),transparent_60%)]"
    />

    <div
      className={cn(
        "relative w-full max-w-[480px] overflow-hidden rounded-2xl md:rounded-[18px]",
        "border border-[var(--line)] bg-white",
        "shadow-[0_24px_60px_-20px_rgba(0,47,73,.18),0_6px_18px_-6px_rgba(0,47,73,.08)]",
        className
      )}
    >
      <div className="flex items-center justify-center pt-5 px-[18px] sm:pt-[22px] sm:px-[22px] md:pt-[26px] md:px-9 bg-[linear-gradient(180deg,rgba(245,157,21,.05),transparent)]">
        <Link to="/" aria-label="TREVEX home" className="flex items-center">
          <Logo className="h-7 w-auto sm:h-9 md:h-10" />
        </Link>
      </div>

      <div className="px-[18px] pt-5 pb-6 sm:px-[22px] sm:pt-6 sm:pb-[26px] md:p-9">
        {children}
      </div>
    </div>
  </main>
);

export default AuthCard;
